import React, { useContext, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { List, ListItem } from 'Lib/List'
import PageLoader from 'Lib/Pageloader'
import Warn from 'Lib/Status/icons/warning.svg'
import SectionHeader from 'Lib/Text/SectionHeader'
import { AccountsContext } from 'AccountsContext'

import {
  TRIPS_LOAD_MSG_HEADING,
  TRIPS_LOAD_MSG_SUBHEADING,
  TRIPS_FETCH_ERROR_MESSAGE,
  SEE_ALL_BOOKINGS_TEXT
} from 'AccountsConstants/language/trips'
import { TRIPLIST_HEADER } from 'AccountsConstants/language/account'
// import { CLEVERTAP_EVENT_NAME, CLEVERTAP_PLATFORM } from 'AccountsConstants/clevertap'
import { ROUTER_BASE_PATH, LOAD_TRIP_LIST } from 'AccountsConstants/routes'
import {
  // readCookie,
  checkUserLogin,
  // navigateToExternalLink,
  // triggerClevertap
} from 'AccountsUtils'
import { TripListContext } from '../context'
import TripsListItem from './TripsListItem'
import NoTripsAvailable from '../NoTripAvailable'
import { getAuthenticated } from '../../../pages/Trips/trips.helper'

// import Login from '../../Login'

const TripsList = props => {
  const {
    trips,
    tripsLoading,
    tripsLoadingFailed,
    fetchAllTrips,
  } = useContext(TripListContext)

  const {
    isLoggedIn,
    checkSignIn,
    checkVerification
  } = useContext(AccountsContext)

  // const id = decodeURI(readCookie('userid')).split('|')[4]

  const deleteCookie = name => {
    document.cookie =
      `${name
      }=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=qa2.cleartrip.ae`
    document.cookie =
      `${name
      }=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=.cleartrip.ae`
    document.cookie =
      `${name
      }=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=cleartrip.ae`
    document.cookie =
      `${name
      }=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=qa2.cleartrip.ae`
  }

  useEffect(() => {
    if (checkUserLogin()) {
      const getAuthenticatedApiResponse = async () => {
        const resp = await getAuthenticated()
        const { status, error } = resp
        if (error?.response?.status === 401 || status !== 200) {
          deleteCookie('userid')
          window.localStorage.removeItem('ON_LOGIN_PUSH')
          window.location.href = '/signout'
        }
      }
      getAuthenticatedApiResponse()
    }
  }, [])

  useEffect(() => {
    // if (!id) {
    //   navigateToExternalLink(LOGOUT_LINK)
    // }
    if (!isLoggedIn) {
      checkSignIn()
    }
    checkVerification()
    const apiData = {
      firstCall: true,
      pageSize: 5,
      pageNo: 0,
      tripStatus: 'upcoming'
    }
    if (!trips || !trips.length) {
      fetchAllTrips(apiData)
    }
  }, [])

  let tripsList = null
  // if (isLoggedIn) {
  //   tripsList = (
  //     <Login />
  //   )
  // } else if (tripsLoading) {
  if (tripsLoading) {
    tripsList = (
      <PageLoader
        title={TRIPS_LOAD_MSG_HEADING}
        message={TRIPS_LOAD_MSG_SUBHEADING}
      />
    )
  } else if (tripsLoadingFailed) {
    tripsList = (
      <List className="amt-10">
        <ListItem arrow={false} enableRipple={false}>
          <div className="flag h-15">
            <div className="flag__fix mr-15">
              <Warn fill="#c30" width="36px" height="36px" />
            </div>
            <div className="flag__flex">
              <h5 className="fs-17 lh-solid c-black-80">
                {TRIPS_FETCH_ERROR_MESSAGE}
              </h5>
            </div>
          </div>
        </ListItem>
      </List>
    )
  } else if (trips.length) {
    if (trips.length < 4) {
      tripsList = (
        <List className="amt-10">
          {trips.map((trip, index) => (
            <TripsListItem
              tripDetails={trip}
              key={trip.trip_ref}
            />
          ))}
        </List>
      )
    } else {
      const shortened_list = trips
      shortened_list.length = 5
      tripsList = (
        <List className="amt-10">
          {trips.map((trip, index) => (
            <TripsListItem
              tripDetails={trip}
              key={trip.trip_ref}
            />
          ))}
          <ListItem arrow={false} enableRipple={true}>
            <Link to={`${ROUTER_BASE_PATH}${LOAD_TRIP_LIST}`} className="flag h-48">
              <div className="flag__flex">
                <h5 className="ta-c fs-17 lh-solid c-blue">
                  {SEE_ALL_BOOKINGS_TEXT}
                </h5>
              </div>
            </Link>
          </ListItem>
        </List>
      )
    }
  } else {
    tripsList = (
      <NoTripsAvailable loggedIn={checkUserLogin()} />
    )
  }

  return (
    <React.Fragment>
      <SectionHeader marginTop="20">{TRIPLIST_HEADER}</SectionHeader>
      {tripsList}
    </React.Fragment>
  )
}

export default TripsList
